import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { PIRedirect } from '../nav';
import api from '../../api/paidit-api';
import Branch from './Branch';
import Loading from '../loading/Loading';
import { useOrderType, usePageTitle } from '../../hooks';
import { setBranch } from '../../actions/BusinessActions';
import { resetState } from '../../actions';

import './BranchPicker.scss';

const nameSorter = (a, b) => a.name > b.name ? 1 : -1;

const BranchPicker = ({ location, ...props }) => {
    const orderType = new URLSearchParams(location.search).get('orderType') || 'takeaway';
    const [branches, setBranches] = useState([]);
    const dispatch = useDispatch();
    const chainId = useSelector(state => state.business.chain.id);
    const selectedBranch = useSelector(state => state.business.branch);
    const isLoading = useSelector(state => state.loading.queue.length > 0);

    usePageTitle('pageTitles.chooseBranch');
    useOrderType(orderType);

    useEffect(() => {
        if (chainId && !selectedBranch) {
            api().chain.fetchBranches(chainId, orderType).then(branches => {
                if (branches.length === 1) {
                    dispatch(setBranch(branches[0]));
                } else if (branches.length === 0) {
                    dispatch(resetState());
                } else {
                    setBranches(branches);
                }
            });
        }
    }, [chainId, selectedBranch, orderType, dispatch]);

    if (selectedBranch) {
        return <PIRedirect to='/order' />;
    }

    if (!chainId) {
        return <PIRedirect to='/' />;
    }

    return (
        <div className="pi-branches-picker">
            <Loading showLoading={isLoading} />
            {branches.sort(nameSorter).map(branch => (<Branch key={branch.id} branch={branch} />))}
        </div>
    );
};

BranchPicker.propTypes = {
    location: PropTypes.object
};

export default BranchPicker;
